import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'
import { Content, Step } from '@/types/partnerConfig'

const { FOOTERLINKS, LOGOS, USA } = DEFAULT
const { CONTENT, BOOK_APPOINTMENT, CONFIG_WITH_FAMILY_AND_ELIGIBILITY } = USA
const { WELCOME, REGISTRATION, FAMILY, SUMMARY, ELIGIBILITY } = CONTENT

const partnerName = 'Fidelis 360'

const welcomeContent: Step = {
  ...WELCOME.enUS,
  copy: [
    'We’ve partnered with Fidelis Care to provide you and your family 24/7 healthcare at no cost, right from your phone.',
  ],
}

const content: Content = {
  'en-US': {
    steps: [
      {
        ...welcomeContent,
        productFeatures: [
          {
            ...BOOK_APPOINTMENT.enUS,
            title:
              'Book a video appointment to talk to a doctor 24 hours a day 7 days a week',
          },
          {
            ...BOOK_APPOINTMENT.enUS,
            title: 'Speak to a therapist Monday through Friday 7 am - 7 pm',
          },
        ],
      },
      {
        ...REGISTRATION.enUS,
        copy: ['Enter your details to access Babylon’s services'],
      },
      {
        ...FAMILY.enUS,
        copy: [
          'Add your family members so they can have access to our services',
        ],
      },
      ELIGIBILITY.enUS,
      SUMMARY.enUS,
    ],
    footerLinks: FOOTERLINKS.USA,
  },
}

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY,
    id: 'fidelis-medicaid-b-360',
    productConfigAppName: 'fidelis-medicaid-b-360',
    name: partnerName,
    codes: {
      membership: 'fidelisb360autoapp',
    },
    partnerUrlSlug: 'fidelis360',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
